import * as React from 'react';
import { useSlate } from 'slate-react';
import styled from 'styled-components';

import { getNodes } from '../../../../../slatePlugins/common/queries/getNodes';
import { Typography } from '../../../../DesignSystemV2/Typography';
import { Separator } from '../../../../Layout/Landing/Content/Separator';
import ColorSelector from '../../highlight/toolbar/ColorSelector';
import { ELEMENT_BORDER_SHADING } from '../defaults';
import {
  removeBorderShadingBackgroundColor,
  setBorderShadingBackgroundColor,
} from '../transform/setBorderShadingColor';
import { BorderShadingColorDefinition } from '../types';

const Layout = styled.div`
  display: grid;
  grid-auto-flow: column;
  column-gap: 4px;
  align-items: center;
`;

export interface ColorMenuProps {
  defaultColorKey: string;
  colors: BorderShadingColorDefinition[];
}

export const ColorMenu = (props: ColorMenuProps) => {
  const { defaultColorKey, colors } = props;
  const editor = useSlate();
  const [node] = getNodes(editor, { match: { type: ELEMENT_BORDER_SHADING } as any }) as any;
  let currentColor = null;
  if (node) {
    currentColor = node[0].colorKey;
  }

  return (
    <Layout>
      <ColorSelector
        colors={colors}
        currentColor={currentColor || defaultColorKey}
        onSelectColor={(color: BorderShadingColorDefinition) => {
          setBorderShadingBackgroundColor(editor, color);
        }}
      />
      <Separator variant="vertical" backgroundColor="gray10" />
      <Typography.Text
        onMouseDown={() => removeBorderShadingBackgroundColor(editor)}
        variant="medium/14"
        color="black100"
      >
        Remove Border
      </Typography.Text>
    </Layout>
  );
};
